import { useQuery } from '@tanstack/react-query'
import { payoutsApi } from '@/services/api'

/**
 * #1998 B3 — is PAYOUTS_ENABLED on here? `isResolved` stays false until the
 * server has answered. Callers that hide things treat an unresolved or failed
 * check as OFF, so nothing payout-related flashes in where payouts are off.
 * Pass `active = false` while there is no session: the endpoint needs one.
 */
export function usePayoutsEnabled(active = true): { enabled: boolean; isResolved: boolean } {
  const query = useQuery({
    queryKey: ['payouts-config'],
    queryFn: () => payoutsApi.getConfig(),
    enabled: active,
    staleTime: 5 * 60 * 1000,
  })
  return { enabled: query.data?.data?.enabled === true, isResolved: query.isSuccess }
}
